import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_DOMAIN_EXTERNAL, API_PATH } from '../config/api.constants';
import { Observable, Subject } from 'rxjs';
import { RequestBody } from 'src/app/models/event-interface';
import {
  DigitalMaterialRequestAttribute,
  PaperMaterialRequestAttribute,
} from 'src/app/models/material-interface';
import { environment } from '../../../environments/environment';
import { SupportedLang } from '../config/localized-paths';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly endpoint = environment.domainendpoint;

  private _userOpenLesson = new Subject<{ lessonId: string; lessonPath?: string; lessonTitle?: string }>();
  readonly userOpenLessonChanges$ = this._userOpenLesson.asObservable();

  constructor(private readonly http: HttpClient) {}

  createDigitalMaterial(
    materialDetails: DigitalMaterialRequestAttribute
  ): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.createDigitalMaterial,
      method: 'POST',
      requestBody: materialDetails,
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  createPaperMaterial(
    materialDetails: PaperMaterialRequestAttribute
  ): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.createPaperMaterial,
      method: 'POST',
      requestBody: materialDetails,
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  submitContactUs(contactUsDetails): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.submitContactUs,
      method: 'POST',
      requestBody: contactUsDetails,
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  getSchoolMetaData(zipCode: string): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.getSchoolMetaData + zipCode,
      method: 'GET',
      requestBody: null,
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  createSchoolMetaData(schoolObj): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.createSchoolMetaData,
      method: 'POST',
      requestBody: schoolObj,
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  getQuizAnswer(quizAnswer: any): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.getQuizAnswer,
      method: 'POST',
      requestBody: quizAnswer
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  getLessonContent(path: string): Observable<any> {
    const encodedPath = encodeURIComponent(path);
    return this.http.get<any>(
      this.endpoint + `api/learning-library/lesson?path=${encodedPath}`
    );
  }

  getLessonQuiz(path: string): Observable<any> {
    const encodedPath = encodeURIComponent(path);
    return this.http.get<any>(
      this.endpoint+`api/learning-library/quiz?path=${encodedPath}`
    );
  }

  getInvestLearningData(): Observable<any> {
    return this.http.get<any>(this.endpoint + 'api/learning-library/all-lessons');
  }

  getHowDidYouHearAboutUs(locale: string): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.getHowDidYouHearAboutUs + locale,
      method: 'GET',
      requestBody: null
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  savePublicLearningLibraryScore(publicLearningLibraryScoreObj): Observable<any> {
    const apiRequestBody: RequestBody = {
      endpoint: API_PATH.savePublicLearningLibraryScore,
      method: 'POST',
      requestBody: publicLearningLibraryScoreObj
    };
    return this.http.post<any>(API_DOMAIN_EXTERNAL.url, apiRequestBody);
  }

  getGlobalBannerMessages(locale: SupportedLang = 'en'): Observable<any> {
    return this.http.get<any>(
      this.endpoint + `api/global-banner-message/all-messages?locale=${encodeURIComponent(locale)}`
    );
  }
}
